export const ALPHA_DOMAIN =
  'customer-communication-hub.alpha.atlas.training.aws.dev';
export const PROD_DOMAIN = 'customer-communication-hub.aws.training';
export const PROD_VIAS_USER_AUTHORIZATION_KEY_NAME =
  'aws/atlas/cch/prod:account_type';
export const DEV_VIAS_USER_AUTHORIZATION_KEY_NAME =
  'aws/atlas/cch/dev:dev_account_type';
